import { cx } from "@/lib/cx";

import styles from "./Spinner.module.css";

export interface SpinnerProps {
  /** Accessible text; omit when a parent already announces the busy state (e.g. a button with aria-busy). */
  label?: string;
  className?: string | undefined;
}

/** Small ring for a button's busy state (`Button` `loading`). Other waits use `LoadingOrb`. */
export function Spinner({ label, className }: SpinnerProps) {
  return (
    <span
      className={cx(styles.spinner, className)}
      role={label === undefined ? undefined : "status"}
    >
      {label !== undefined && <span className="sr-only">{label}</span>}
    </span>
  );
}
